import { connect } from 'react-redux';
import {
    selectClientConfigurations,
    hasBalanceSheetOverviewEnabled,
} from 'state/user/selectors';
import AnalyticsNavbar from 'components/analytics/components/AnalyticsNavbar/AnalyticsNavbar';

const mapState = (state) => {
    const clientConfig = selectClientConfigurations(state);
    const {
        FEATURE_NATIVE_ANALYTICS_RANKING: isRankingEnabled,
        FEATURE_PORTFOLIO_SEGMENTATION: isSegmentationEnabled,
    } = clientConfig;

    return {
        isRankingEnabled,
        isSegmentationEnabled,
        isBalanceSheetOverviewEnabled: hasBalanceSheetOverviewEnabled(state),
    };
};

export default connect(mapState, null, null, { pure: false })(AnalyticsNavbar);
